import classNames from 'classnames'
import React from 'react'
import {TextButton} from 'wix-ui-tpa/TextButton'
import {classes} from './no-events-link.st.css'
import {NoEventsLinkProps} from '.'

export const NoEventsLink = ({mobile, ...rest}: NoEventsLinkProps) => (
  <TextButton {...rest} className={classNames(classes.root, {[classes.mobile]: mobile})} />
)
